import React from 'react'
import PDSInfo from 'components/PDSInfo'
import { getDisclosures } from 'utils/disclosures-util'
import { useTranslation } from 'react-i18next'

const disclosures = getDisclosures()

export const usePdsInfo = (priceComparisonResponse, dealerName, dealerPhoneNumber, transactionType) => {
    const { t } = useTranslation()

    // Calculate the size of the increasesResponse and decreaseResponse objects
    const increasesResponseSize = priceComparisonResponse?.increasesResponse
        ? Object.keys(priceComparisonResponse?.increasesResponse).length
        : 0
    const decreaseResponseSize = priceComparisonResponse?.decreaseResponse
        ? Object.keys(priceComparisonResponse?.decreaseResponse).length
        : 0

    // Calculate the total number of price changes
    const totalPriceChanges = parseInt(increasesResponseSize) + parseInt(decreaseResponseSize)

    const formattedTotalPrice = priceComparisonResponse?.total

    const bannerPriceMessage = formattedTotalPrice
        ? (Math.sign(formattedTotalPrice) === -1 && t('banner_dec_price_message')) || t('banner_inc_price_message')
        : t('banner_inc_price_message')

    // Determine the appropriate PDSInfo component based on the priceComparisonResponse
    let infoNotify = null

    if (priceComparisonResponse?.vinNumberChanged) {
        // Show PDSInfo with VIN message if vinNumberChanged is true
        infoNotify = (
            <PDSInfo
                priceData={priceComparisonResponse}
                bannerMessage={t('banner_vin_message')}
                isViewChangesEnabled={false}
                dealerName={dealerName}
                dealerPhoneNumber={dealerPhoneNumber}
                transactionType={transactionType}
            />
        )
    } else if (priceComparisonResponse?.invalidFinanceTypeConversion) {
        // Show PDSInfo with finance type message if invalidFinanceTypeConversion is true
        infoNotify = (
            <PDSInfo
                priceData={priceComparisonResponse}
                bannerMessage={t('banner_fin_message')}
                isViewChangesEnabled={false}
                dealerName={dealerName}
                dealerPhoneNumber={dealerPhoneNumber}
                transactionType={transactionType}
            />
        )
    } else if (priceComparisonResponse?.other == 0 && totalPriceChanges > 0) {
        // Show PDSInfo with price message if totalPriceChanges is greater than 0 & others should be equal to zero.
        infoNotify = (
            <PDSInfo
                priceData={priceComparisonResponse}
                bannerMessage={bannerPriceMessage}
                isViewChangesEnabled={true}
                dealerName={dealerName}
                dealerPhoneNumber={dealerPhoneNumber}
                transactionType={transactionType}
            />
        )
    }
    let disc = { ...disclosures }
    disc['documentFee'].name = priceComparisonResponse?.documentFee?.name || disclosures['documentFee'].name
    const sortedDiscloures = Object.values(disc).sort((a, b) => a.order - b.order)
    // Return the infoNotify component
    return { infoNotify, sortedDiscloures }
}
